
import './Planning.scss'
import OnboardSchedule from './schedule/OnboardSchedule'
import GroundContact from './ground_contact/GroundContact'
import useUrlParams from '../../../hooks/useUrlParams'
import ControlSchedule from './schedule/ControlSchedule';
import SecurityConfigurations from './security-configurations/SecurityConfigurations';
import { SCENARIO_DEPLOYMENT_TYPES } from '../../../../simulate/constants';
import { isOperateMode } from '../../../hooks/utils';
import useScenario from '../../../hooks/useScenario';

const Planning = () => {

    const { tab_name, dashboard } = useUrlParams()
    const { scenario } = useScenario()

    const operateMode = isOperateMode(dashboard, scenario)
    const isValidateSummary =
        (scenario?.scenarioDeploymentType ?? '').toUpperCase() === SCENARIO_DEPLOYMENT_TYPES.VALIDATE &&
        dashboard === 'summary'

    return (
        <div className={`planning__container__wrapper ${isValidateSummary ? 'readonly-summary' : ''}`}>
            <div className={`planning__container ${(operateMode && tab_name === 'plan-onboard-schedule') && 'ps-0'}`}>
                {isValidateSummary ? (
                    tab_name === 'plan-security-configuration'
                        ? <SecurityConfigurations />
                        : <OnboardSchedule />
                ) : (
                    <>
                        {tab_name === 'plan-onboard-schedule' && <OnboardSchedule />}
                        {tab_name === 'plan-control-schedule' && <ControlSchedule />}
                        {tab_name === 'plan-ground-contact' && <GroundContact />}
                        {tab_name === 'plan-security-configuration' && <SecurityConfigurations />}
                    </>
                )}
            </div>
        </div>
    )
}

export default Planning